import type { IProjectRoleUpdatedNotificationData } from "@frontend-shared/types";
import { Shield } from "lucide-react";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useTranslateRoleName } from "@/hooks/use-translate-role-name";

import { NotificationCardShell } from "../NotificationCardShell";

interface IProjectRoleUpdatedCardProps {
  uuid: string;
  data: IProjectRoleUpdatedNotificationData;
  createdAt: string;
  isRead: boolean;
  onViewProject: (organizationUuid: string) => void;
}

const ProjectRoleUpdatedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
  onViewProject,
}: IProjectRoleUpdatedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");
  const translateRoleName = useTranslateRoleName();

  const handleViewProject = useCallback(
    () => onViewProject(data.organizationUuid),
    [onViewProject, data.organizationUuid],
  );

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="project_role_updated"
      createdAt={createdAt}
      isRead={isRead}
      icon={<Shield className="h-5 w-5" />}
      ctaLabel={t("view_project")}
      onCtaClick={handleViewProject}
      body={t("type.project_role_updated.body", {
        changedByName: data.changedByName,
        projectTitle: data.projectTitle,
        newRoleName: translateRoleName(data.newRoleName),
      })}
    />
  );
};

export const ProjectRoleUpdatedCard = memo(ProjectRoleUpdatedCardComponent);
